export const moreScreen = {
  en: {
    // Main Screen
    title: 'More',
    subtitle: 'Explore additional features, settings, and personalization options',
    
    // Menu Items
    profile: 'Profile',
    profileSubtitle: 'View and edit your profile',
    leaderboard: 'Leaderboard',
    leaderboardSubtitle: 'See rankings and compete',
    progressAchievements: 'Progress & Achievements',
    progressSubtitle: 'Track your spiritual journey',
    settings: 'Settings',
    settingsSubtitle: 'App preferences and configuration',
    quizTutorial: 'Quiz Tutorial',
    tutorialSubtitle: 'Learn how to play Bible quizzes',
    privacySettings: 'Privacy Settings',
    privacySubtitle: 'Control your data and privacy preferences',
    
    // Footer
    appTitle: 'Kingdom Bible Quiz',
    footerTagline: 'Deepening faith through interactive learning',
    
    // Tutorial Completion Screen
    tutorialComplete: 'Tutorial Complete!',
    tutorialCompleteMessage: 'You\'re ready to take Bible quizzes. The tutorial is always available here if you need a refresher.',
    backToMenu: 'Back to More Menu',
    
    // Navigation Headers
    backButton: 'Back',
    profileHeader: 'Profile',
    leaderboardHeader: 'Leaderboard',
    progressHeader: 'Progress & Achievements',
    settingsHeader: 'Settings',
    tutorialHeader: 'Quiz Tutorial',
    privacyHeader: 'Privacy Settings',
    
    // Privacy Settings Screen
    privacyTitle: 'Privacy Settings',
    // privacySubtitle: 'Control your data and privacy preferences', // Duplicate - already defined at line 19
    
    // Data Collection Section
    dataCollection: 'Data Collection',
    analytics: 'Analytics',
    analyticsDescription: 'Help improve the app by sharing anonymous usage data',
    
    // Community Privacy Section
    communityPrivacy: 'Community Privacy',
    communityVisibility: 'Community Visibility',
    communityVisibilityDescription: 'Control who can see your profile and quiz activity',
    public: 'Public',
    publicDescription: 'Visible to everyone',
    friendsOnly: 'Friends Only',
    friendsOnlyDescription: 'Visible to friends',
    private: 'Private',
    privateDescription: 'Hidden from others',
    shareQuizResults: 'Share Quiz Results',
    shareQuizResultsDescription: 'Allow others to see your quiz scores and achievements',
    
    // Notifications Section
    notifications: 'Notifications',
    emailNotifications: 'Email Notifications',
    emailNotificationsDescription: 'Receive updates and announcements via email',
    pushNotifications: 'Push Notifications',
    pushNotificationsDescription: 'Receive app notifications on your device',
    
    // Data Rights Section
    yourDataRights: 'Your Data Rights',
    requestDataExport: 'Request Data Export',
    dataExportDescription: 'Download all your personal data (GDPR)',
    
    // Legal Section
    legal: 'Legal',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    
    // Account Management Section
    accountManagement: 'Account Management',
    deleteAccount: 'Delete Account',
    deleteAccountDescription: 'Permanently delete your account and all data',
    
    // Alert Messages
    error: 'Error',
    cancel: 'Cancel',
    dataExportRequest: 'Data Export Request',
    dataExportMessage: 'We will prepare your data export and send it to your registered email address within 30 days as required by GDPR.',
    requestExport: 'Request Export',
    exportRequested: 'Export Requested',
    exportRequestedMessage: 'Your data export request has been submitted. You will receive an email with your data within 30 days.',
    deleteAccountTitle: 'Delete Account',
    deleteAccountMessage: 'This will permanently delete your account and all associated data. This action cannot be undone.',
    accountDeleted: 'Account Deleted',
    accountDeletedMessage: 'Your account has been permanently deleted.',
    failedUpdatePrivacy: 'Failed to update privacy setting',
    failedDataExport: 'Failed to request data export',
    failedDeleteAccount: 'Failed to delete account. Please try again.',
    
    // FirstQuizTutorial Component
    tutorialStepOf: 'of',
    skipTutorial: 'Skip Tutorial',
    back: 'Back',
    next: 'Next',
    startQuiz: 'Start Quiz',
    
    // Tutorial Steps
    tutorialStep1Title: 'Welcome to Your First Quiz!',
    tutorialStep1Description: 'Let\'s walk through how Bible quizzes work. This tutorial will take just 2 minutes.',
    tutorialStep2Title: 'Choose Your Category',
    tutorialStep2Description: 'Select a Bible topic that interests you. We recommend starting with \'General Bible Knowledge\' for beginners.',
    tutorialStep2Action: 'Tap a category to continue',
    tutorialStep3Title: 'Pick Your Difficulty',
    tutorialStep3Description: 'Choose Easy for a gentle start, Medium for a challenge, or Hard if you\'re confident in your Bible knowledge.',
    tutorialStep3Action: 'Select a difficulty level',
    tutorialStep4Title: 'Read the Question',
    tutorialStep4Description: 'Take your time to read each question carefully. Bible questions often have important details.',
    tutorialStep5Title: 'Choose Your Answer',
    tutorialStep5Description: 'Tap the answer you think is correct. You have 30 seconds per question, but don\'t rush!',
    tutorialStep5Action: 'Tap an answer option',
    tutorialStep6Title: 'Track Your Progress',
    tutorialStep6Description: 'The progress bar shows how many questions you\'ve completed. Most quizzes have 10 questions.',
    tutorialStep7Title: 'Learn from Explanations',
    tutorialStep7Description: 'After each question, you\'ll see an explanation to help you learn and remember the answer.',
    tutorialStep8Title: 'Celebrate Your Results!',
    tutorialStep8Description: 'At the end, you\'ll see your score, earn achievements, and can share your results with friends.',
    
    // Interactive Tips
    tutorialTipCategory: 'Try tapping "General Bible Knowledge"',
    tutorialTipDifficulty: 'Tap "Easy" to get started',

    // Guest User Messages
    notSignedIn: 'Not Signed In',
    guestNoAccount: 'You are playing as a guest. Sign in to create an account and save your progress.',
    ok: 'OK',
  },

  es: {
    // Main Screen
    title: 'Más',
    subtitle: 'Explora funciones adicionales, configuraciones y opciones de personalización',
    
    // Menu Items
    profile: 'Perfil',
    profileSubtitle: 'Ver y editar tu perfil',
    leaderboard: 'Tabla de Clasificación',
    leaderboardSubtitle: 'Ver clasificaciones y competir',
    progressAchievements: 'Progreso y Logros',
    progressSubtitle: 'Rastrea tu jornada espiritual',
    settings: 'Configuración',
    settingsSubtitle: 'Preferencias y configuración de la aplicación',
    quizTutorial: 'Tutorial de Quiz',
    tutorialSubtitle: 'Aprende cómo jugar los quizzes bíblicos',
    privacySettings: 'Configuración de Privacidad',
    privacySubtitle: 'Controla tus datos y preferencias de privacidad',
    
    // Footer
    appTitle: 'Quiz Bíblico del Reino',
    footerTagline: 'Profundizando la fe a través del aprendizaje interactivo',
    
    // Tutorial Completion Screen
    tutorialComplete: '¡Tutorial Completado!',
    tutorialCompleteMessage: 'Estás listo para hacer quizzes bíblicos. El tutorial siempre está disponible aquí si necesitas un repaso.',
    backToMenu: 'Volver al Menú Más',
    
    // Navigation Headers
    backButton: 'Atrás',
    profileHeader: 'Perfil',
    leaderboardHeader: 'Tabla de Clasificación',
    progressHeader: 'Progreso y Logros',
    settingsHeader: 'Configuración',
    tutorialHeader: 'Tutorial de Quiz',
    privacyHeader: 'Configuración de Privacidad',
    
    // Privacy Settings Screen
    privacyTitle: 'Configuración de Privacidad',
    // privacySubtitle: 'Controla tus datos y preferencias de privacidad', // Duplicate - already defined at line 149
    
    // Data Collection Section
    dataCollection: 'Recopilación de Datos',
    analytics: 'Analíticas',
    analyticsDescription: 'Ayuda a mejorar la aplicación compartiendo datos de uso anónimos',
    
    // Community Privacy Section
    communityPrivacy: 'Privacidad de la Comunidad',
    communityVisibility: 'Visibilidad de la Comunidad',
    communityVisibilityDescription: 'Controla quién puede ver tu perfil y actividad de quiz',
    public: 'Público',
    publicDescription: 'Visible para todos',
    friendsOnly: 'Solo Amigos',
    friendsOnlyDescription: 'Visible para amigos',
    private: 'Privado',
    privateDescription: 'Oculto de otros',
    shareQuizResults: 'Compartir Resultados de Quiz',
    shareQuizResultsDescription: 'Permitir que otros vean tus puntuaciones y logros de quiz',
    
    // Notifications Section
    notifications: 'Notificaciones',
    emailNotifications: 'Notificaciones por Email',
    emailNotificationsDescription: 'Recibir actualizaciones y anuncios por email',
    pushNotifications: 'Notificaciones Push',
    pushNotificationsDescription: 'Recibir notificaciones de la aplicación en tu dispositivo',
    
    // Data Rights Section
    yourDataRights: 'Tus Derechos de Datos',
    requestDataExport: 'Solicitar Exportación de Datos',
    dataExportDescription: 'Descargar todos tus datos personales (GDPR)',
    
    // Legal Section
    legal: 'Legal',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    
    // Account Management Section
    accountManagement: 'Gestión de Cuenta',
    deleteAccount: 'Eliminar Cuenta',
    deleteAccountDescription: 'Eliminar permanentemente tu cuenta y todos los datos',
    
    // Alert Messages
    error: 'Error',
    cancel: 'Cancelar',
    dataExportRequest: 'Solicitud de Exportación de Datos',
    dataExportMessage: 'Prepararemos tu exportación de datos y la enviaremos a tu dirección de email registrada dentro de 30 días según requiere el GDPR.',
    requestExport: 'Solicitar Exportación',
    exportRequested: 'Exportación Solicitada',
    exportRequestedMessage: 'Tu solicitud de exportación de datos ha sido enviada. Recibirás un email con tus datos dentro de 30 días.',
    deleteAccountTitle: 'Eliminar Cuenta',
    deleteAccountMessage: 'Esto eliminará permanentemente tu cuenta y todos los datos asociados. Esta acción no se puede deshacer.',
    accountDeleted: 'Cuenta Eliminada',
    accountDeletedMessage: 'Tu cuenta ha sido eliminada permanentemente.',
    failedUpdatePrivacy: 'Error al actualizar configuración de privacidad',
    failedDataExport: 'Error al solicitar exportación de datos',
    failedDeleteAccount: 'Error al eliminar cuenta. Por favor intenta de nuevo.',
    
    // FirstQuizTutorial Component
    tutorialStepOf: 'de',
    skipTutorial: 'Saltar Tutorial',
    back: 'Atrás',
    next: 'Siguiente',
    startQuiz: 'Comenzar Quiz',
    
    // Tutorial Steps
    tutorialStep1Title: '¡Bienvenido a tu Primer Quiz!',
    tutorialStep1Description: 'Veamos cómo funcionan los quizzes bíblicos. Este tutorial tomará solo 2 minutos.',
    tutorialStep2Title: 'Elige tu Categoría',
    tutorialStep2Description: 'Selecciona un tema bíblico que te interese. Recomendamos comenzar con \'Conocimiento General de la Biblia\' para principiantes.',
    tutorialStep2Action: 'Toca una categoría para continuar',
    tutorialStep3Title: 'Elige tu Dificultad',
    tutorialStep3Description: 'Elige Fácil para un comienzo suave, Medio para un desafío, o Difícil si tienes confianza en tu conocimiento bíblico.',
    tutorialStep3Action: 'Selecciona un nivel de dificultad',
    tutorialStep4Title: 'Lee la Pregunta',
    tutorialStep4Description: 'Tómate tu tiempo para leer cada pregunta cuidadosamente. Las preguntas bíblicas a menudo tienen detalles importantes.',
    tutorialStep5Title: 'Elige tu Respuesta',
    tutorialStep5Description: 'Toca la respuesta que crees que es correcta. Tienes 30 segundos por pregunta, ¡pero no te apresures!',
    tutorialStep5Action: 'Toca una opción de respuesta',
    tutorialStep6Title: 'Rastrea tu Progreso',
    tutorialStep6Description: 'La barra de progreso muestra cuántas preguntas has completado. La mayoría de los quizzes tienen 10 preguntas.',
    tutorialStep7Title: 'Aprende de las Explicaciones',
    tutorialStep7Description: 'Después de cada pregunta, verás una explicación para ayudarte a aprender y recordar la respuesta.',
    tutorialStep8Title: '¡Celebra tus Resultados!',
    tutorialStep8Description: 'Al final, verás tu puntuación, ganarás logros y podrás compartir tus resultados con amigos.',
    
    // Interactive Tips
    tutorialTipCategory: 'Intenta tocar "Conocimiento General de la Biblia"',
    tutorialTipDifficulty: 'Toca "Fácil" para comenzar',

    // Guest User Messages
    notSignedIn: 'No has iniciado sesión',
    guestNoAccount: 'Estás jugando como invitado. Inicia sesión para crear una cuenta y guardar tu progreso.',
    ok: 'OK',
  },

  fr: {
    // Main Screen
    title: 'Plus',
    subtitle: 'Explorez des fonctionnalités supplémentaires, paramètres et options de personnalisation',
    
    // Menu Items
    profile: 'Profil',
    profileSubtitle: 'Voir et modifier votre profil',
    leaderboard: 'Classement',
    leaderboardSubtitle: 'Voir les classements et concourir',
    progressAchievements: 'Progrès et Réussites',
    progressSubtitle: 'Suivez votre parcours spirituel',
    settings: 'Paramètres',
    settingsSubtitle: 'Préférences et configuration de l\'application',
    quizTutorial: 'Tutoriel Quiz',
    tutorialSubtitle: 'Apprenez comment jouer aux quiz bibliques',
    privacySettings: 'Paramètres de Confidentialité',
    privacySubtitle: 'Contrôlez vos données et préférences de confidentialité',
    
    // Footer
    appTitle: 'Quiz Biblique du Royaume',
    footerTagline: 'Approfondir la foi grâce à l\'apprentissage interactif',
    
    // Tutorial Completion Screen
    tutorialComplete: 'Tutoriel Terminé !',
    tutorialCompleteMessage: 'Vous êtes prêt à faire des quiz bibliques. Le tutoriel est toujours disponible ici si vous avez besoin d\'un rappel.',
    backToMenu: 'Retour au Menu Plus',
    
    // Navigation Headers
    backButton: 'Retour',
    profileHeader: 'Profil',
    leaderboardHeader: 'Classement',
    progressHeader: 'Progrès et Réussites',
    settingsHeader: 'Paramètres',
    tutorialHeader: 'Tutoriel Quiz',
    privacyHeader: 'Paramètres de Confidentialité',
    
    // Privacy Settings Screen
    privacyTitle: 'Paramètres de Confidentialité',
    // privacySubtitle: 'Contrôlez vos données et préférences de confidentialité', // Duplicate - already defined at line 279
    
    // Data Collection Section
    dataCollection: 'Collecte de Données',
    analytics: 'Analytiques',
    analyticsDescription: 'Aidez à améliorer l\'application en partageant des données d\'utilisation anonymes',
    
    // Community Privacy Section
    communityPrivacy: 'Confidentialité Communautaire',
    communityVisibility: 'Visibilité Communautaire',
    communityVisibilityDescription: 'Contrôlez qui peut voir votre profil et activité de quiz',
    public: 'Public',
    publicDescription: 'Visible par tous',
    friendsOnly: 'Amis Seulement',
    friendsOnlyDescription: 'Visible par les amis',
    private: 'Privé',
    privateDescription: 'Caché des autres',
    shareQuizResults: 'Partager les Résultats de Quiz',
    shareQuizResultsDescription: 'Permettre aux autres de voir vos scores et réussites de quiz',
    
    // Notifications Section
    notifications: 'Notifications',
    emailNotifications: 'Notifications Email',
    emailNotificationsDescription: 'Recevoir des mises à jour et annonces par email',
    pushNotifications: 'Notifications Push',
    pushNotificationsDescription: 'Recevoir des notifications d\'application sur votre appareil',
    
    // Data Rights Section
    yourDataRights: 'Vos Droits sur les Données',
    requestDataExport: 'Demander l\'Exportation de Données',
    dataExportDescription: 'Télécharger toutes vos données personnelles (RGPD)',
    
    // Legal Section
    legal: 'Légal',
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: 'Conditions de Service',
    
    // Account Management Section
    accountManagement: 'Gestion de Compte',
    deleteAccount: 'Supprimer le Compte',
    deleteAccountDescription: 'Supprimer définitivement votre compte et toutes les données',
    
    // Alert Messages
    error: 'Erreur',
    cancel: 'Annuler',
    dataExportRequest: 'Demande d\'Exportation de Données',
    dataExportMessage: 'Nous préparerons votre exportation de données et l\'enverrons à votre adresse email enregistrée dans les 30 jours comme requis par le RGPD.',
    requestExport: 'Demander l\'Exportation',
    exportRequested: 'Exportation Demandée',
    exportRequestedMessage: 'Votre demande d\'exportation de données a été soumise. Vous recevrez un email avec vos données dans les 30 jours.',
    deleteAccountTitle: 'Supprimer le Compte',
    deleteAccountMessage: 'Ceci supprimera définitivement votre compte et toutes les données associées. Cette action ne peut pas être annulée.',
    accountDeleted: 'Compte Supprimé',
    accountDeletedMessage: 'Votre compte a été supprimé définitivement.',
    failedUpdatePrivacy: 'Échec de la mise à jour des paramètres de confidentialité',
    failedDataExport: 'Échec de la demande d\'exportation de données',
    failedDeleteAccount: 'Échec de la suppression du compte. Veuillez réessayer.',
    
    // FirstQuizTutorial Component
    tutorialStepOf: 'de',
    skipTutorial: 'Passer le Tutoriel',
    back: 'Retour',
    next: 'Suivant',
    startQuiz: 'Commencer le Quiz',
    
    // Tutorial Steps
    tutorialStep1Title: 'Bienvenue à votre Premier Quiz !',
    tutorialStep1Description: 'Découvrons comment fonctionnent les quiz bibliques. Ce tutoriel ne prendra que 2 minutes.',
    tutorialStep2Title: 'Choisissez votre Catégorie',
    tutorialStep2Description: 'Sélectionnez un sujet biblique qui vous intéresse. Nous recommandons de commencer par \'Connaissance Générale de la Bible\' pour les débutants.',
    tutorialStep2Action: 'Touchez une catégorie pour continuer',
    tutorialStep3Title: 'Choisissez votre Difficulté',
    tutorialStep3Description: 'Choisissez Facile pour un début en douceur, Moyen pour un défi, ou Difficile si vous êtes confiant dans vos connaissances bibliques.',
    tutorialStep3Action: 'Sélectionnez un niveau de difficulté',
    tutorialStep4Title: 'Lisez la Question',
    tutorialStep4Description: 'Prenez votre temps pour lire chaque question attentivement. Les questions bibliques ont souvent des détails importants.',
    tutorialStep5Title: 'Choisissez votre Réponse',
    tutorialStep5Description: 'Touchez la réponse que vous pensez être correcte. Vous avez 30 secondes par question, mais ne vous pressez pas !',
    tutorialStep5Action: 'Touchez une option de réponse',
    tutorialStep6Title: 'Suivez votre Progrès',
    tutorialStep6Description: 'La barre de progression montre combien de questions vous avez complétées. La plupart des quiz ont 10 questions.',
    tutorialStep7Title: 'Apprenez des Explications',
    tutorialStep7Description: 'Après chaque question, vous verrez une explication pour vous aider à apprendre et mémoriser la réponse.',
    tutorialStep8Title: 'Célébrez vos Résultats !',
    tutorialStep8Description: 'À la fin, vous verrez votre score, gagnerez des succès et pourrez partager vos résultats avec des amis.',
    
    // Interactive Tips
    tutorialTipCategory: 'Essayez de toucher "Connaissance Générale de la Bible"',
    tutorialTipDifficulty: 'Touchez "Facile" pour commencer',

    // Guest User Messages
    notSignedIn: 'Non connecté',
    guestNoAccount: 'Vous jouez en tant qu\'invité. Connectez-vous pour créer un compte et sauvegarder votre progression.',
    ok: 'OK',
  },

  de: {
    // Main Screen
    title: 'Mehr',
    subtitle: 'Entdecken Sie zusätzliche Funktionen, Einstellungen und Personalisierungsoptionen',
    
    // Menu Items
    profile: 'Profil',
    profileSubtitle: 'Ihr Profil anzeigen und bearbeiten',
    leaderboard: 'Bestenliste',
    leaderboardSubtitle: 'Ranglisten anzeigen und konkurrieren',
    progressAchievements: 'Fortschritt & Erfolge',
    progressSubtitle: 'Verfolgen Sie Ihre spirituelle Reise',
    settings: 'Einstellungen',
    settingsSubtitle: 'App-Einstellungen und Konfiguration',
    quizTutorial: 'Quiz Tutorial',
    tutorialSubtitle: 'Lernen Sie, wie man Bibel-Quiz spielt',
    privacySettings: 'Datenschutz-Einstellungen',
    privacySubtitle: 'Kontrollieren Sie Ihre Daten und Datenschutz-Einstellungen',
    
    // Footer
    appTitle: 'Kingdom Bibel Quiz',
    footerTagline: 'Glauben durch interaktives Lernen vertiefen',
    
    // Tutorial Completion Screen
    tutorialComplete: 'Tutorial Abgeschlossen!',
    tutorialCompleteMessage: 'Sie sind bereit, Bibel-Quiz zu machen. Das Tutorial ist immer hier verfügbar, wenn Sie eine Auffrischung benötigen.',
    backToMenu: 'Zurück zum Mehr-Menü',
    
    // Navigation Headers
    backButton: 'Zurück',
    profileHeader: 'Profil',
    leaderboardHeader: 'Bestenliste',
    progressHeader: 'Fortschritt & Erfolge',
    settingsHeader: 'Einstellungen',
    tutorialHeader: 'Quiz Tutorial',
    privacyHeader: 'Datenschutz-Einstellungen',
    
    // Privacy Settings Screen
    privacyTitle: 'Datenschutz-Einstellungen',
    // privacySubtitle: 'Kontrollieren Sie Ihre Daten und Datenschutz-Einstellungen', // Duplicate - already defined at line 409
    
    // Data Collection Section
    dataCollection: 'Datenerfassung',
    analytics: 'Analytik',
    analyticsDescription: 'Helfen Sie dabei, die App zu verbessern, indem Sie anonyme Nutzungsdaten teilen',
    
    // Community Privacy Section
    communityPrivacy: 'Community-Datenschutz',
    communityVisibility: 'Community-Sichtbarkeit',
    communityVisibilityDescription: 'Kontrollieren Sie, wer Ihr Profil und Ihre Quiz-Aktivitäten sehen kann',
    public: 'Öffentlich',
    publicDescription: 'Für alle sichtbar',
    friendsOnly: 'Nur Freunde',
    friendsOnlyDescription: 'Für Freunde sichtbar',
    private: 'Privat',
    privateDescription: 'Für andere verborgen',
    shareQuizResults: 'Quiz-Ergebnisse teilen',
    shareQuizResultsDescription: 'Anderen erlauben, Ihre Quiz-Ergebnisse und Erfolge zu sehen',
    
    // Notifications Section
    notifications: 'Benachrichtigungen',
    emailNotifications: 'E-Mail-Benachrichtigungen',
    emailNotificationsDescription: 'Updates und Ankündigungen per E-Mail erhalten',
    pushNotifications: 'Push-Benachrichtigungen',
    pushNotificationsDescription: 'App-Benachrichtigungen auf Ihrem Gerät erhalten',
    
    // Data Rights Section
    yourDataRights: 'Ihre Datenrechte',
    requestDataExport: 'Datenexport anfordern',
    dataExportDescription: 'Alle Ihre persönlichen Daten herunterladen (DSGVO)',
    
    // Legal Section
    legal: 'Rechtliches',
    privacyPolicy: 'Datenschutzrichtlinie',
    termsOfService: 'Nutzungsbedingungen',
    
    // Account Management Section
    accountManagement: 'Kontoverwaltung',
    deleteAccount: 'Konto löschen',
    deleteAccountDescription: 'Ihr Konto und alle Daten dauerhaft löschen',
    
    // Alert Messages
    error: 'Fehler',
    cancel: 'Abbrechen',
    dataExportRequest: 'Datenexport-Anfrage',
    dataExportMessage: 'Wir werden Ihren Datenexport vorbereiten und ihn innerhalb von 30 Tagen gemäß DSGVO an Ihre registrierte E-Mail-Adresse senden.',
    requestExport: 'Export anfordern',
    exportRequested: 'Export angefordert',
    exportRequestedMessage: 'Ihre Datenexport-Anfrage wurde eingereicht. Sie erhalten innerhalb von 30 Tagen eine E-Mail mit Ihren Daten.',
    deleteAccountTitle: 'Konto löschen',
    deleteAccountMessage: 'Dies wird Ihr Konto und alle zugehörigen Daten dauerhaft löschen. Diese Aktion kann nicht rückgängig gemacht werden.',
    accountDeleted: 'Konto gelöscht',
    accountDeletedMessage: 'Ihr Konto wurde dauerhaft gelöscht.',
    failedUpdatePrivacy: 'Fehler beim Aktualisieren der Datenschutz-Einstellungen',
    failedDataExport: 'Fehler beim Anfordern des Datenexports',
    failedDeleteAccount: 'Fehler beim Löschen des Kontos. Bitte versuchen Sie es erneut.',
    
    // FirstQuizTutorial Component
    tutorialStepOf: 'von',
    skipTutorial: 'Tutorial Überspringen',
    back: 'Zurück',
    next: 'Weiter',
    startQuiz: 'Quiz Starten',
    
    // Tutorial Steps
    tutorialStep1Title: 'Willkommen zu Ihrem ersten Quiz!',
    tutorialStep1Description: 'Lassen Sie uns durchgehen, wie Bibel-Quiz funktionieren. Dieses Tutorial dauert nur 2 Minuten.',
    tutorialStep2Title: 'Wählen Sie Ihre Kategorie',
    tutorialStep2Description: 'Wählen Sie ein Bibelthema, das Sie interessiert. Wir empfehlen, mit \'Allgemeines Bibelwissen\' für Anfänger zu beginnen.',
    tutorialStep2Action: 'Tippen Sie auf eine Kategorie, um fortzufahren',
    tutorialStep3Title: 'Wählen Sie Ihre Schwierigkeit',
    tutorialStep3Description: 'Wählen Sie Einfach für einen sanften Start, Mittel für eine Herausforderung oder Schwer, wenn Sie sich in Ihrem Bibelwissen sicher sind.',
    tutorialStep3Action: 'Wählen Sie eine Schwierigkeitsstufe',
    tutorialStep4Title: 'Lesen Sie die Frage',
    tutorialStep4Description: 'Nehmen Sie sich Zeit, jede Frage sorgfältig zu lesen. Bibelfragen haben oft wichtige Details.',
    tutorialStep5Title: 'Wählen Sie Ihre Antwort',
    tutorialStep5Description: 'Tippen Sie auf die Antwort, die Sie für richtig halten. Sie haben 30 Sekunden pro Frage, aber lassen Sie sich nicht drängen!',
    tutorialStep5Action: 'Tippen Sie auf eine Antwortoption',
    tutorialStep6Title: 'Verfolgen Sie Ihren Fortschritt',
    tutorialStep6Description: 'Der Fortschrittsbalken zeigt, wie viele Fragen Sie beantwortet haben. Die meisten Quiz haben 10 Fragen.',
    tutorialStep7Title: 'Lernen Sie aus Erklärungen',
    tutorialStep7Description: 'Nach jeder Frage sehen Sie eine Erklärung, die Ihnen hilft, die Antwort zu lernen und zu merken.',
    tutorialStep8Title: 'Feiern Sie Ihre Ergebnisse!',
    tutorialStep8Description: 'Am Ende sehen Sie Ihre Punktzahl, verdienen Erfolge und können Ihre Ergebnisse mit Freunden teilen.',
    
    // Interactive Tips
    tutorialTipCategory: 'Versuchen Sie, auf "Allgemeines Bibelwissen" zu tippen',
    tutorialTipDifficulty: 'Tippen Sie auf "Einfach", um zu beginnen',

    // Guest User Messages
    notSignedIn: 'Nicht angemeldet',
    guestNoAccount: 'Sie spielen als Gast. Melden Sie sich an, um ein Konto zu erstellen und Ihren Fortschritt zu speichern.',
    ok: 'OK',
  },

  pt: {
    // Main Screen
    title: 'Mais',
    subtitle: 'Explore recursos adicionais, configurações e opções de personalização',
    
    // Menu Items
    profile: 'Perfil',
    profileSubtitle: 'Ver e editar seu perfil',
    leaderboard: 'Classificação',
    leaderboardSubtitle: 'Ver rankings e competir',
    progressAchievements: 'Progresso e Conquistas',
    progressSubtitle: 'Acompanhe sua jornada espiritual',
    settings: 'Configurações',
    settingsSubtitle: 'Preferências e configuração do aplicativo',
    quizTutorial: 'Tutorial do Quiz',
    tutorialSubtitle: 'Aprenda como jogar quiz bíblicos',
    privacySettings: 'Configurações de Privacidade',
    privacySubtitle: 'Controle seus dados e preferências de privacidade',
    
    // Footer
    appTitle: 'Quiz Bíblico do Reino',
    footerTagline: 'Aprofundando a fé através do aprendizado interativo',
    
    // Tutorial Completion Screen
    tutorialComplete: 'Tutorial Concluído!',
    tutorialCompleteMessage: 'Você está pronto para fazer quiz bíblicos. O tutorial está sempre disponível aqui se precisar de uma revisão.',
    backToMenu: 'Voltar ao Menu Mais',
    
    // Navigation Headers
    backButton: 'Voltar',
    profileHeader: 'Perfil',
    leaderboardHeader: 'Classificação',
    progressHeader: 'Progresso e Conquistas',
    settingsHeader: 'Configurações',
    tutorialHeader: 'Tutorial do Quiz',
    privacyHeader: 'Configurações de Privacidade',
    
    // Privacy Settings Screen
    privacyTitle: 'Configurações de Privacidade',
    // privacySubtitle: 'Controle seus dados e preferências de privacidade', // Duplicate - already defined at line 539
    
    // Data Collection Section
    dataCollection: 'Coleta de Dados',
    analytics: 'Análises',
    analyticsDescription: 'Ajude a melhorar o aplicativo compartilhando dados de uso anônimos',
    
    // Community Privacy Section
    communityPrivacy: 'Privacidade da Comunidade',
    communityVisibility: 'Visibilidade da Comunidade',
    communityVisibilityDescription: 'Controle quem pode ver seu perfil e atividade de quiz',
    public: 'Público',
    publicDescription: 'Visível para todos',
    friendsOnly: 'Apenas Amigos',
    friendsOnlyDescription: 'Visível para amigos',
    private: 'Privado',
    privateDescription: 'Oculto de outros',
    shareQuizResults: 'Compartilhar Resultados de Quiz',
    shareQuizResultsDescription: 'Permitir que outros vejam suas pontuações e conquistas de quiz',
    
    // Notifications Section
    notifications: 'Notificações',
    emailNotifications: 'Notificações por Email',
    emailNotificationsDescription: 'Receber atualizações e anúncios por email',
    pushNotifications: 'Notificações Push',
    pushNotificationsDescription: 'Receber notificações do aplicativo em seu dispositivo',
    
    // Data Rights Section
    yourDataRights: 'Seus Direitos de Dados',
    requestDataExport: 'Solicitar Exportação de Dados',
    dataExportDescription: 'Baixar todos os seus dados pessoais (LGPD)',
    
    // Legal Section
    legal: 'Legal',
    privacyPolicy: 'Política de Privacidade',
    termsOfService: 'Termos de Serviço',
    
    // Account Management Section
    accountManagement: 'Gerenciamento de Conta',
    deleteAccount: 'Excluir Conta',
    deleteAccountDescription: 'Excluir permanentemente sua conta e todos os dados',
    
    // Alert Messages
    error: 'Erro',
    cancel: 'Cancelar',
    dataExportRequest: 'Solicitação de Exportação de Dados',
    dataExportMessage: 'Prepararemos sua exportação de dados e a enviaremos para seu endereço de email registrado dentro de 30 dias conforme exigido pela LGPD.',
    requestExport: 'Solicitar Exportação',
    exportRequested: 'Exportação Solicitada',
    exportRequestedMessage: 'Sua solicitação de exportação de dados foi enviada. Você receberá um email com seus dados dentro de 30 dias.',
    deleteAccountTitle: 'Excluir Conta',
    deleteAccountMessage: 'Isso excluirá permanentemente sua conta e todos os dados associados. Esta ação não pode ser desfeita.',
    accountDeleted: 'Conta Excluída',
    accountDeletedMessage: 'Sua conta foi excluída permanentemente.',
    failedUpdatePrivacy: 'Falha ao atualizar configurações de privacidade',
    failedDataExport: 'Falha ao solicitar exportação de dados',
    failedDeleteAccount: 'Falha ao excluir conta. Tente novamente.',
    
    // FirstQuizTutorial Component
    tutorialStepOf: 'de',
    skipTutorial: 'Pular Tutorial',
    back: 'Voltar',
    next: 'Próximo',
    startQuiz: 'Iniciar Quiz',
    
    // Tutorial Steps
    tutorialStep1Title: 'Bem-vindo ao seu Primeiro Quiz!',
    tutorialStep1Description: 'Vamos ver como funcionam os quiz bíblicos. Este tutorial levará apenas 2 minutos.',
    tutorialStep2Title: 'Escolha sua Categoria',
    tutorialStep2Description: 'Selecione um tópico bíblico que lhe interesse. Recomendamos começar com \'Conhecimento Geral da Bíblia\' para iniciantes.',
    tutorialStep2Action: 'Toque em uma categoria para continuar',
    tutorialStep3Title: 'Escolha sua Dificuldade',
    tutorialStep3Description: 'Escolha Fácil para um começo suave, Médio para um desafio, ou Difícil se você confia no seu conhecimento bíblico.',
    tutorialStep3Action: 'Selecione um nível de dificuldade',
    tutorialStep4Title: 'Leia a Pergunta',
    tutorialStep4Description: 'Dedique tempo para ler cada pergunta cuidadosamente. Perguntas bíblicas frequentemente têm detalhes importantes.',
    tutorialStep5Title: 'Escolha sua Resposta',
    tutorialStep5Description: 'Toque na resposta que você acha que está correta. Você tem 30 segundos por pergunta, mas não se apresse!',
    tutorialStep5Action: 'Toque em uma opção de resposta',
    tutorialStep6Title: 'Acompanhe seu Progresso',
    tutorialStep6Description: 'A barra de progresso mostra quantas perguntas você completou. A maioria dos quiz tem 10 perguntas.',
    tutorialStep7Title: 'Aprenda com as Explicações',
    tutorialStep7Description: 'Após cada pergunta, você verá uma explicação para ajudá-lo a aprender e lembrar da resposta.',
    tutorialStep8Title: 'Comemore seus Resultados!',
    tutorialStep8Description: 'No final, você verá sua pontuação, ganhará conquistas e poderá compartilhar seus resultados com amigos.',
    
    // Interactive Tips
    tutorialTipCategory: 'Tente tocar em "Conhecimento Geral da Bíblia"',
    tutorialTipDifficulty: 'Toque em "Fácil" para começar',

    // Guest User Messages
    notSignedIn: 'Não conectado',
    guestNoAccount: 'Você está jogando como convidado. Entre para criar uma conta e salvar seu progresso.',
    ok: 'OK',
  },

  ru: {
    // Main Screen
    title: 'Ещё',
    subtitle: 'Изучите дополнительные функции, настройки и параметры персонализации',
    
    // Menu Items
    profile: 'Профиль',
    profileSubtitle: 'Просмотр и редактирование вашего профиля',
    leaderboard: 'Таблица Лидеров',
    leaderboardSubtitle: 'Посмотреть рейтинги и соревноваться',
    progressAchievements: 'Прогресс и Достижения',
    progressSubtitle: 'Отслеживайте свой духовный путь',
    settings: 'Настройки',
    settingsSubtitle: 'Предпочтения и конфигурация приложения',
    quizTutorial: 'Обучение Викторине',
    tutorialSubtitle: 'Узнайте, как играть в библейские викторины',
    privacySettings: 'Настройки Конфиденциальности',
    privacySubtitle: 'Контролируйте ваши данные и настройки конфиденциальности',
    
    // Footer
    appTitle: 'Библейская Викторина Царства',
    footerTagline: 'Углубление веры через интерактивное обучение',
    
    // Tutorial Completion Screen
    tutorialComplete: 'Обучение Завершено!',
    tutorialCompleteMessage: 'Вы готовы к библейским викторинам. Обучение всегда доступно здесь, если вам нужно освежить знания.',
    backToMenu: 'Назад в Меню Ещё',
    
    // Navigation Headers
    backButton: 'Назад',
    profileHeader: 'Профиль',
    leaderboardHeader: 'Таблица Лидеров',
    progressHeader: 'Прогресс и Достижения',
    settingsHeader: 'Настройки',
    tutorialHeader: 'Обучение Викторине',
    privacyHeader: 'Настройки Конфиденциальности',
    
    // Privacy Settings Screen
    privacyTitle: 'Настройки Конфиденциальности',
    // privacySubtitle: 'Контролируйте ваши данные и настройки конфиденциальности', // Duplicate - already defined at line 669
    
    // Data Collection Section
    dataCollection: 'Сбор Данных',
    analytics: 'Аналитика',
    analyticsDescription: 'Помогите улучшить приложение, делясь анонимными данными использования',
    
    // Community Privacy Section
    communityPrivacy: 'Конфиденциальность Сообщества',
    communityVisibility: 'Видимость в Сообществе',
    communityVisibilityDescription: 'Контролируйте, кто может видеть ваш профиль и активность в викторинах',
    public: 'Публичный',
    publicDescription: 'Видимый для всех',
    friendsOnly: 'Только Друзья',
    friendsOnlyDescription: 'Видимый для друзей',
    private: 'Приватный',
    privateDescription: 'Скрытый от других',
    shareQuizResults: 'Делиться Результатами Викторин',
    shareQuizResultsDescription: 'Позволить другим видеть ваши результаты и достижения в викторинах',
    
    // Notifications Section
    notifications: 'Уведомления',
    emailNotifications: 'Email Уведомления',
    emailNotificationsDescription: 'Получать обновления и объявления по email',
    pushNotifications: 'Push Уведомления',
    pushNotificationsDescription: 'Получать уведомления приложения на вашем устройстве',
    
    // Data Rights Section
    yourDataRights: 'Ваши Права на Данные',
    requestDataExport: 'Запросить Экспорт Данных',
    dataExportDescription: 'Скачать все ваши персональные данные (GDPR)',
    
    // Legal Section
    legal: 'Правовая информация',
    privacyPolicy: 'Политика Конфиденциальности',
    termsOfService: 'Условия Использования',
    
    // Account Management Section
    accountManagement: 'Управление Аккаунтом',
    deleteAccount: 'Удалить Аккаунт',
    deleteAccountDescription: 'Навсегда удалить ваш аккаунт и все данные',
    
    // Alert Messages
    error: 'Ошибка',
    cancel: 'Отмена',
    dataExportRequest: 'Запрос Экспорта Данных',
    dataExportMessage: 'Мы подготовим экспорт ваших данных и отправим их на вашу зарегистрированную электронную почту в течение 30 дней в соответствии с GDPR.',
    requestExport: 'Запросить Экспорт',
    exportRequested: 'Экспорт Запрошен',
    exportRequestedMessage: 'Ваш запрос на экспорт данных был отправлен. Вы получите email с вашими данными в течение 30 дней.',
    deleteAccountTitle: 'Удалить Аккаунт',
    deleteAccountMessage: 'Это навсегда удалит ваш аккаунт и все связанные данные. Это действие нельзя отменить.',
    accountDeleted: 'Аккаунт Удален',
    accountDeletedMessage: 'Ваш аккаунт был навсегда удален.',
    failedUpdatePrivacy: 'Не удалось обновить настройки конфиденциальности',
    failedDataExport: 'Не удалось запросить экспорт данных',
    failedDeleteAccount: 'Не удалось удалить аккаунт. Попробуйте снова.',
    
    // FirstQuizTutorial Component
    tutorialStepOf: 'из',
    skipTutorial: 'Пропустить Обучение',
    back: 'Назад',
    next: 'Далее',
    startQuiz: 'Начать Викторину',
    
    // Tutorial Steps
    tutorialStep1Title: 'Добро пожаловать в вашу первую викторину!',
    tutorialStep1Description: 'Давайте разберем, как работают библейские викторины. Это обучение займет всего 2 минуты.',
    tutorialStep2Title: 'Выберите Категорию',
    tutorialStep2Description: 'Выберите библейскую тему, которая вам интересна. Мы рекомендуем начать с "Общие знания о Библии" для новичков.',
    tutorialStep2Action: 'Коснитесь категории, чтобы продолжить',
    tutorialStep3Title: 'Выберите Сложность',
    tutorialStep3Description: 'Выберите Легко для мягкого начала, Средне для вызова или Трудно, если вы уверены в своем знании Библии.',
    tutorialStep3Action: 'Выберите уровень сложности',
    tutorialStep4Title: 'Прочитайте Вопрос',
    tutorialStep4Description: 'Не торопитесь читать каждый вопрос внимательно. Библейские вопросы часто содержат важные детали.',
    tutorialStep5Title: 'Выберите Ответ',
    tutorialStep5Description: 'Коснитесь ответа, который считаете правильным. У вас есть 30 секунд на вопрос, но не спешите!',
    tutorialStep5Action: 'Коснитесь варианта ответа',
    tutorialStep6Title: 'Отслеживайте Прогресс',
    tutorialStep6Description: 'Полоса прогресса показывает, сколько вопросов вы выполнили. Большинство викторин содержат 10 вопросов.',
    tutorialStep7Title: 'Учитесь на Объяснениях',
    tutorialStep7Description: 'После каждого вопроса вы увидите объяснение, которое поможет вам выучить и запомнить ответ.',
    tutorialStep8Title: 'Отметьте ваши Результаты!',
    tutorialStep8Description: 'В конце вы увидите свой счет, заработаете достижения и сможете поделиться результатами с друзьями.',
    
    // Interactive Tips
    tutorialTipCategory: 'Попробуйте коснуться "Общие знания о Библии"',
    tutorialTipDifficulty: 'Коснитесь "Легко", чтобы начать',

    // Guest User Messages
    notSignedIn: 'Не вошли в систему',
    guestNoAccount: 'Вы играете как гость. Войдите, чтобы создать аккаунт и сохранить свой прогресс.',
    ok: 'ОК',
  },

  tl: {
    // Main Screen
    title: 'Higit Pa',
    subtitle: 'I-explore ang mga karagdagang feature, settings, at mga pagpipilian sa personalization',
    
    // Menu Items
    profile: 'Profile',
    profileSubtitle: 'Tingnan at i-edit ang inyong profile',
    leaderboard: 'Leaderboard',
    leaderboardSubtitle: 'Tingnan ang mga ranking at makipagkompetensya',
    progressAchievements: 'Progress at mga Achievement',
    progressSubtitle: 'I-track ang inyong spiritual journey',
    settings: 'Settings',
    settingsSubtitle: 'Mga preference at configuration ng app',
    quizTutorial: 'Quiz Tutorial',
    tutorialSubtitle: 'Matuto kung paano maglaro ng Bible quiz',
    privacySettings: 'Privacy Settings',
    privacySubtitle: 'I-control ang inyong data at privacy preferences',
    
    // Footer
    appTitle: 'Kingdom Bible Quiz',
    footerTagline: 'Pagpapalalim ng pananampalataya sa pamamagitan ng interactive learning',
    
    // Tutorial Completion Screen
    tutorialComplete: 'Natapos na ang Tutorial!',
    tutorialCompleteMessage: 'Handa na kayong magtake ng Bible quiz. Laging available dito ang tutorial kung kailangan ninyo ng refresher.',
    backToMenu: 'Balik sa More Menu',
    
    // Navigation Headers
    backButton: 'Balik',
    profileHeader: 'Profile',
    leaderboardHeader: 'Leaderboard',
    progressHeader: 'Progress at mga Achievement',
    settingsHeader: 'Settings',
    tutorialHeader: 'Quiz Tutorial',
    privacyHeader: 'Privacy Settings',
    
    // Privacy Settings Screen
    privacyTitle: 'Privacy Settings',
    // privacySubtitle: 'I-control ang inyong data at privacy preferences', // Duplicate - already defined at line 799
    
    // Data Collection Section
    dataCollection: 'Data Collection',
    analytics: 'Analytics',
    analyticsDescription: 'Tumulong na mapabuti ang app sa pamamagitan ng pagbabahagi ng anonymous usage data',
    
    // Community Privacy Section
    communityPrivacy: 'Community Privacy',
    communityVisibility: 'Community Visibility',
    communityVisibilityDescription: 'I-control kung sino ang makakakita sa inyong profile at quiz activity',
    public: 'Public',
    publicDescription: 'Makikita ng lahat',
    friendsOnly: 'Friends Lang',
    friendsOnlyDescription: 'Makikita ng mga friends',
    private: 'Private',
    privateDescription: 'Nakatago sa iba',
    shareQuizResults: 'I-share ang Quiz Results',
    shareQuizResultsDescription: 'Payagan ang iba na makita ang inyong quiz scores at achievements',
    
    // Notifications Section
    notifications: 'Notifications',
    emailNotifications: 'Email Notifications',
    emailNotificationsDescription: 'Makatanggap ng updates at announcements sa email',
    pushNotifications: 'Push Notifications',
    pushNotificationsDescription: 'Makatanggap ng app notifications sa inyong device',
    
    // Data Rights Section
    yourDataRights: 'Mga Karapatan sa Data',
    requestDataExport: 'Humingi ng Data Export',
    dataExportDescription: 'I-download ang lahat ng inyong personal data (GDPR)',
    
    // Legal Section
    legal: 'Legal',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    
    // Account Management Section
    accountManagement: 'Account Management',
    deleteAccount: 'I-delete ang Account',
    deleteAccountDescription: 'Permanenteng i-delete ang inyong account at lahat ng data',
    
    // Alert Messages
    error: 'Error',
    cancel: 'Cancel',
    dataExportRequest: 'Data Export Request',
    dataExportMessage: 'Ihahanda namin ang inyong data export at ipapadala sa inyong registered email address sa loob ng 30 araw ayon sa GDPR.',
    requestExport: 'Request Export',
    exportRequested: 'Na-request na ang Export',
    exportRequestedMessage: 'Na-submit na ang inyong data export request. Makatanggap kayo ng email na may data ninyo sa loob ng 30 araw.',
    deleteAccountTitle: 'I-delete ang Account',
    deleteAccountMessage: 'Permanenteng ide-delete nito ang inyong account at lahat ng associated data. Hindi na ito mababawi.',
    accountDeleted: 'Na-delete na ang Account',
    accountDeletedMessage: 'Permanenteng na-delete na ang inyong account.',
    failedUpdatePrivacy: 'Hindi na-update ang privacy setting',
    failedDataExport: 'Hindi na-request ang data export',
    failedDeleteAccount: 'Hindi na-delete ang account. Subukan ulit.',
    
    // FirstQuizTutorial Component
    tutorialStepOf: 'sa',
    skipTutorial: 'Skip ang Tutorial',
    back: 'Balik',
    next: 'Susunod',
    startQuiz: 'Simulan ang Quiz',
    
    // Tutorial Steps
    tutorialStep1Title: 'Welcome sa inyong First Quiz!',
    tutorialStep1Description: 'Tuklasin natin kung paano gumagana ang Bible quiz. Ang tutorial na ito ay tatagal lang ng 2 minuto.',
    tutorialStep2Title: 'Piliin ang Category',
    tutorialStep2Description: 'Pumili ng Bible topic na nakakainteresa sa inyo. Recommended namin na magsimula sa \'General Bible Knowledge\' para sa mga baguhan.',
    tutorialStep2Action: 'I-tap ang category para magpatuloy',
    tutorialStep3Title: 'Piliin ang Difficulty',
    tutorialStep3Description: 'Piliin ang Easy para sa gentle start, Medium para sa challenge, o Hard kung confident kayo sa inyong Bible knowledge.',
    tutorialStep3Action: 'Pumili ng difficulty level',
    tutorialStep4Title: 'Basahin ang Question',
    tutorialStep4Description: 'Kumuha ng oras para basahin nang mabuti ang bawat tanong. Ang Bible questions ay madalas may important details.',
    tutorialStep5Title: 'Piliin ang Answer',
    tutorialStep5Description: 'I-tap ang sagot na sa tingin ninyo ay tama. May 30 seconds kayo per question, pero huwag magmadali!',
    tutorialStep5Action: 'I-tap ang answer option',
    tutorialStep6Title: 'I-track ang Progress',
    tutorialStep6Description: 'Ang progress bar ay nagpapakita kung ilang tanong na ang natapos ninyo. Karamihan ng quiz ay may 10 questions.',
    tutorialStep7Title: 'Matuto sa Explanations',
    tutorialStep7Description: 'Pagkatapos ng bawat tanong, makikita ninyo ang explanation para makatulong sa pag-aaral at pagaalala ng sagot.',
    tutorialStep8Title: 'I-celebrate ang Results!',
    tutorialStep8Description: 'Sa dulo, makikita ninyo ang score, makakakuha ng achievements, at pwedeng i-share ang results sa mga kaibigan.',
    
    // Interactive Tips
    tutorialTipCategory: 'Subukan i-tap ang "General Bible Knowledge"',
    tutorialTipDifficulty: 'I-tap ang "Easy" para magsimula',

    // Guest User Messages
    notSignedIn: 'Hindi naka-sign in',
    guestNoAccount: 'Naglalaro ka bilang bisita. Mag-sign in para lumikha ng account at i-save ang iyong progress.',
    ok: 'OK',
  },

  it: {
    // Main Screen
    title: 'Altro',
    subtitle: 'Esplora funzionalità aggiuntive, impostazioni e opzioni di personalizzazione',
    
    // Menu Items
    profile: 'Profilo',
    profileSubtitle: 'Visualizza e modifica il tuo profilo',
    leaderboard: 'Classifica',
    leaderboardSubtitle: 'Vedi le classifiche e gareggia',
    progressAchievements: 'Progresso e Traguardi',
    progressSubtitle: 'Segui il tuo percorso spirituale',
    settings: 'Impostazioni',
    settingsSubtitle: 'Preferenze e configurazione dell\'app',
    quizTutorial: 'Tutorial Quiz',
    tutorialSubtitle: 'Impara come giocare ai quiz biblici',
    privacySettings: 'Impostazioni Privacy',
    privacySubtitle: 'Controlla i tuoi dati e le preferenze sulla privacy',
    
    // Footer
    appTitle: 'Quiz Biblico del Regno',
    footerTagline: 'Approfondire la fede attraverso l\'apprendimento interattivo',
    
    // Tutorial Completion Screen
    tutorialComplete: 'Tutorial Completato!',
    tutorialCompleteMessage: 'Sei pronto per fare quiz biblici. Il tutorial è sempre disponibile qui se hai bisogno di un ripasso.',
    backToMenu: 'Torna al Menu Altro',
    
    // Navigation Headers
    backButton: 'Indietro',
    profileHeader: 'Profilo',
    leaderboardHeader: 'Classifica',
    progressHeader: 'Progresso e Traguardi',
    settingsHeader: 'Impostazioni',
    tutorialHeader: 'Tutorial Quiz',
    privacyHeader: 'Impostazioni Privacy',
    
    // Privacy Settings Screen
    privacyTitle: 'Impostazioni Privacy',
    // privacySubtitle: 'Controlla i tuoi dati e le preferenze sulla privacy', // Duplicate - already defined at line 929
    
    // Data Collection Section
    dataCollection: 'Raccolta Dati',
    analytics: 'Analitiche',
    analyticsDescription: 'Aiuta a migliorare l\'app condividendo dati di utilizzo anonimi',
    
    // Community Privacy Section
    communityPrivacy: 'Privacy della Comunità',
    communityVisibility: 'Visibilità della Comunità',
    communityVisibilityDescription: 'Controlla chi può vedere il tuo profilo e l\'attività dei quiz',
    public: 'Pubblico',
    publicDescription: 'Visibile a tutti',
    friendsOnly: 'Solo Amici',
    friendsOnlyDescription: 'Visibile agli amici',
    private: 'Privato',
    privateDescription: 'Nascosto agli altri',
    shareQuizResults: 'Condividi Risultati Quiz',
    shareQuizResultsDescription: 'Permetti ad altri di vedere i tuoi punteggi e traguardi dei quiz',
    
    // Notifications Section
    notifications: 'Notifiche',
    emailNotifications: 'Notifiche Email',
    emailNotificationsDescription: 'Ricevi aggiornamenti e annunci via email',
    pushNotifications: 'Notifiche Push',
    pushNotificationsDescription: 'Ricevi notifiche dell\'app sul tuo dispositivo',
    
    // Data Rights Section
    yourDataRights: 'I Tuoi Diritti sui Dati',
    requestDataExport: 'Richiedi Esportazione Dati',
    dataExportDescription: 'Scarica tutti i tuoi dati personali (GDPR)',
    
    // Legal Section
    legal: 'Legale',
    privacyPolicy: 'Politica sulla Privacy',
    termsOfService: 'Termini di Servizio',
    
    // Account Management Section
    accountManagement: 'Gestione Account',
    deleteAccount: 'Elimina Account',
    deleteAccountDescription: 'Elimina permanentemente il tuo account e tutti i dati',
    
    // Alert Messages
    error: 'Errore',
    cancel: 'Annulla',
    dataExportRequest: 'Richiesta Esportazione Dati',
    dataExportMessage: 'Prepareremo l\'esportazione dei tuoi dati e la invieremo al tuo indirizzo email registrato entro 30 giorni come richiesto dal GDPR.',
    requestExport: 'Richiedi Esportazione',
    exportRequested: 'Esportazione Richiesta',
    exportRequestedMessage: 'La tua richiesta di esportazione dati è stata inviata. Riceverai un\'email con i tuoi dati entro 30 giorni.',
    deleteAccountTitle: 'Elimina Account',
    deleteAccountMessage: 'Questo eliminerà permanentemente il tuo account e tutti i dati associati. Questa azione non può essere annullata.',
    accountDeleted: 'Account Eliminato',
    accountDeletedMessage: 'Il tuo account è stato eliminato permanentemente.',
    failedUpdatePrivacy: 'Aggiornamento impostazioni privacy fallito',
    failedDataExport: 'Richiesta esportazione dati fallita',
    failedDeleteAccount: 'Eliminazione account fallita. Riprova.',
    
    // FirstQuizTutorial Component
    tutorialStepOf: 'di',
    skipTutorial: 'Salta Tutorial',
    back: 'Indietro',
    next: 'Avanti',
    startQuiz: 'Inizia Quiz',
    
    // Tutorial Steps
    tutorialStep1Title: 'Benvenuto al tuo Primo Quiz!',
    tutorialStep1Description: 'Vediamo come funzionano i quiz biblici. Questo tutorial richiederà solo 2 minuti.',
    tutorialStep2Title: 'Scegli la tua Categoria',
    tutorialStep2Description: 'Seleziona un argomento biblico che ti interessa. Consigliamo di iniziare con \'Conoscenza Generale della Bibbia\' per i principianti.',
    tutorialStep2Action: 'Tocca una categoria per continuare',
    tutorialStep3Title: 'Scegli la tua Difficoltà',
    tutorialStep3Description: 'Scegli Facile per un inizio dolce, Medio per una sfida, o Difficile se sei sicuro della tua conoscenza biblica.',
    tutorialStep3Action: 'Seleziona un livello di difficoltà',
    tutorialStep4Title: 'Leggi la Domanda',
    tutorialStep4Description: 'Prenditi il tempo per leggere attentamente ogni domanda. Le domande bibliche spesso hanno dettagli importanti.',
    tutorialStep5Title: 'Scegli la tua Risposta',
    tutorialStep5Description: 'Tocca la risposta che pensi sia corretta. Hai 30 secondi per domanda, ma non affrettarti!',
    tutorialStep5Action: 'Tocca un\'opzione di risposta',
    tutorialStep6Title: 'Tieni traccia del tuo Progresso',
    tutorialStep6Description: 'La barra di progresso mostra quante domande hai completato. La maggior parte dei quiz ha 10 domande.',
    tutorialStep7Title: 'Impara dalle Spiegazioni',
    tutorialStep7Description: 'Dopo ogni domanda, vedrai una spiegazione per aiutarti a imparare e ricordare la risposta.',
    tutorialStep8Title: 'Celebra i tuoi Risultati!',
    tutorialStep8Description: 'Alla fine, vedrai il tuo punteggio, guadagnerai risultati e potrai condividere i tuoi risultati con gli amici.',
    
    // Interactive Tips
    tutorialTipCategory: 'Prova a toccare "Conoscenza Generale della Bibbia"',
    tutorialTipDifficulty: 'Tocca "Facile" per iniziare',

    // Guest User Messages
    notSignedIn: 'Non connesso',
    guestNoAccount: 'Stai giocando come ospite. Accedi per creare un account e salvare i tuoi progressi.',
    ok: 'OK',
  },

  am: {
    // Main Screen
    title: 'ተጨማሪ',
    subtitle: 'ተጨማሪ ባህሪያት፣ ቅንብሮች እና የግላዊነት አማራጮችን ይመርምሩ',
    
    // Menu Items
    profile: 'መገለጫ',
    profileSubtitle: 'የእርስዎን መገለጫ ይመልከቱ እና ያርትዑ',
    leaderboard: 'የመሪዎች ሰሌዳ',
    leaderboardSubtitle: 'ደረጃዎችን ይመልከቱ እና ወዳዱ',
    progressAchievements: 'እድገት እና ስኬቶች',
    progressSubtitle: 'የእርስዎን መንፈሳዊ ጉዞ ይከታተሉ',
    settings: 'ቅንብሮች',
    settingsSubtitle: 'የመተግበሪያ ምርጫዎች እና ውቅር',
    quizTutorial: 'የጥያቄ መማሪያ',
    tutorialSubtitle: 'የመጽሐፍ ቅዱስ ጥያቄዎችን እንዴት እንደሚጫወቱ ይማሩ',
    privacySettings: 'የግላዊነት ቅንብሮች',
    privacySubtitle: 'የእርስዎን ውሂብ እና የግላዊነት ምርጫዎችን ይቆጣጠሩ',
    
    // Footer
    appTitle: 'የመንግሥተ ሰማያት መጽሐፍ ቅዱስ ጥያቄ',
    footerTagline: 'በይነተግባር ትምህርት የእምነትን ማጠናከር',
    
    // Tutorial Completion Screen
    tutorialComplete: 'መማሪያ ተጠናቅቋል!',
    tutorialCompleteMessage: 'የመጽሐፍ ቅዱስ ጥያቄዎችን ለመውሰድ ዝግጁ ነዎት። ከፈለጉ መማሪያው ሁልጊዜ እዚህ ይገኛል።',
    backToMenu: 'ወደ ተጨማሪ ምናሌ ይመለሱ',
    
    // Navigation Headers
    backButton: 'ተመለስ',
    profileHeader: 'መገለጫ',
    leaderboardHeader: 'የመሪዎች ሰሌዳ',
    progressHeader: 'እድገት እና ስኬቶች',
    settingsHeader: 'ቅንብሮች',
    tutorialHeader: 'የጥያቄ መማሪያ',
    privacyHeader: 'የግላዊነት ቅንብሮች',
    
    // Privacy Settings Screen
    privacyTitle: 'የግላዊነት ቅንብሮች',
    // privacySubtitle: 'የእርስዎን ውሂብ እና የግላዊነት ምርጫዎችን ይቆጣጠሩ', // Duplicate - already defined at line 1059
    
    // Data Collection Section
    dataCollection: 'የውሂብ ስብሰባ',
    analytics: 'ትንታኔዎች',
    analyticsDescription: 'አልታወቀ የአጠቃቀም ውሂብ በማጋራት መተግበሪያውን ማሻሻል ይርዱ',
    
    // Community Privacy Section
    communityPrivacy: 'የማህበረሰብ ግላዊነት',
    communityVisibility: 'የማህበረሰብ እይታ',
    communityVisibilityDescription: 'መገለጫዎን እና የጥያቄ እንቅስቃሴዎን ማን እንደሚያይ ይቆጣጠሩ',
    public: 'ሕዝባዊ',
    publicDescription: 'ለሁሉም የሚታይ',
    friendsOnly: 'ለጓደኞች ብቻ',
    friendsOnlyDescription: 'ለጓደኞች የሚታይ',
    private: 'ግላዊ',
    privateDescription: 'ከሌሎች የተሸሸገ',
    shareQuizResults: 'የጥያቄ ውጤቶችን አጋራ',
    shareQuizResultsDescription: 'ሌሎች የእርስዎን የጥያቄ ነጥቦች እና ስኬቶች እንዲያዩ ያስችሉ',
    
    // Notifications Section
    notifications: 'ማሳወቂያዎች',
    emailNotifications: 'የኢሜል ማሳወቂያዎች',
    emailNotificationsDescription: 'ማሻሻያዎችን እና መግለጫዎችን በኢሜል ይቀበሉ',
    pushNotifications: 'የ Push ማሳወቂያዎች',
    pushNotificationsDescription: 'በመሳሪያዎ ላይ የመተግበሪያ ማሳወቂያዎችን ይቀበሉ',
    
    // Data Rights Section
    yourDataRights: 'የእርስዎ የውሂብ መብቶች',
    requestDataExport: 'የውሂብ ወጣት ይጠይቁ',
    dataExportDescription: 'ሁሉንም የእርስዎን ግላዊ ውሂብ ያውርዱ (GDPR)',
    
    // Legal Section
    legal: 'ሕጋዊ',
    privacyPolicy: 'የግላዊነት ፖሊሲ',
    termsOfService: 'የአገልግሎት ውሎች',
    
    // Account Management Section
    accountManagement: 'የመለያ አስተዳደር',
    deleteAccount: 'መለያን ሰርዝ',
    deleteAccountDescription: 'መለያዎን እና ሁሉንም ውሂብ በቋሚነት ይሰርዙ',
    
    // Alert Messages
    error: 'ስህተት',
    cancel: 'ሰርዝ',
    dataExportRequest: 'የውሂብ ወጣት ጥያቄ',
    dataExportMessage: 'የእርስዎን የውሂብ ወጣት እናዘጋጃለን እና በ GDPR እንደሚጠበቀው በ30 ቀናት ውስጥ ወደ የተመዘገበ ኢሜል አድራሻዎ እንልካለን።',
    requestExport: 'ወጣት ይጠይቁ',
    exportRequested: 'ወጣት ተጠይቋል',
    exportRequestedMessage: 'የእርስዎ የውሂብ ወጣት ጥያቄ ቀርቧል። በ30 ቀናት ውስጥ ከውሂብዎ ጋር ኢሜል ይቀበላሉ።',
    deleteAccountTitle: 'መለያን ሰርዝ',
    deleteAccountMessage: 'ይህ መለያዎን እና ሁሉንም ተዛማጅ ውሂብ በቋሚነት ይሰርዛል። ይህንን ድርጊት መመለስ አይቻልም።',
    accountDeleted: 'መለያ ተሰርዟል',
    accountDeletedMessage: 'መለያዎ በቋሚነት ተሰርዟል።',
    failedUpdatePrivacy: 'የግላዊነት ቅንብር ማሻሻያ አልተሳካም',
    failedDataExport: 'የውሂብ ወጣት ጥያቄ አልተሳካም',
    failedDeleteAccount: 'መለያ መሰረዝ አልተሳካም። እንደገና ይሞክሩ።',
    
    // FirstQuizTutorial Component
    tutorialStepOf: 'ከ',
    skipTutorial: 'መማሪያውን ይለፉ',
    back: 'ተመለስ',
    next: 'የሚቀጥለው',
    startQuiz: 'ጥያቄ ይጀምሩ',
    
    // Tutorial Steps
    tutorialStep1Title: 'ወደ የመጀመሪያ የጥያቄ ውድድር ዘወትር ያስገቡ!',
    tutorialStep1Description: 'የመጽሐፍ ቅዱስ ጥያቄዎች እንዴት እንደሚሰሩ እንመልከት። ይህ መማሪያ የሚወስደው 2 ደቂቃ ብቻ ነው።',
    tutorialStep2Title: 'ክፍልዎን ይመርጡ',
    tutorialStep2Description: 'የሚያስፈልግዎ የመጽሐፍ ቅዱስ ርዕሰ ጉዳይ ይምረጡ። ለጀማሪዎች "የመጽሐፍ ቅዱስ አጠቃላይ እውቀት" መጀመር እንመክራለን።',
    tutorialStep2Action: 'ለመቀጠል ክፍል ይንኩ',
    tutorialStep3Title: 'ችግርዎን ይምረጡ',
    tutorialStep3Description: 'ለደገና ጅምር ቀላል፣ ለፈተና መካከለኛ፣ ወይም በመጽሐፍ ቅዱስ እውቀትዎ የመተማመን ካለዎት ከባድ ይምረጡ።',
    tutorialStep3Action: 'የችግር ደረጃ ይምረጡ',
    tutorialStep4Title: 'ጥያቄውን ያንብቡ',
    tutorialStep4Description: 'እያንዳንዱን ጥያቄ በጥንቃቄ ለማንበብ ጊዜ ይውሰዱ። የመጽሐፍ ቅዱስ ጥያቄዎች ብዙ ጊዜ አስፈላጊ ዝርዝሮች አሏቸው።',
    tutorialStep5Title: 'መልስዎን ይምረጡ',
    tutorialStep5Description: 'ትክክል ነው ብለው የሚያስቡትን መልስ ይንኩ። በጥያቄ 30 ሰከንድ አለዎት፣ ግን አይቸኩሉ!',
    tutorialStep5Action: 'የመልስ አማራጭ ይንኩ',
    tutorialStep6Title: 'እድገትዎን ይከታተሉ',
    tutorialStep6Description: 'የእድገት መመሪያ ምን ያህል ጥያቄዎችን እንደጨረሱ ያሳያል። አብዛኛዎቹ ጥያቄዎች 10 ጥያቄዎች አሏቸው።',
    tutorialStep7Title: 'ከማብራሪያዎች ይማሩ',
    tutorialStep7Description: 'ከእያንዳንዱ ጥያቄ በኋላ፣ መልሱን ለመማር እና ለማስታወስ የሚያግዝ ማብራሪያ ይመለከታሉ።',
    tutorialStep8Title: 'ውጤቶችዎን ያከብሩ!',
    tutorialStep8Description: 'በመጨረሻ፣ ነጥብዎን ይመለከታሉ፣ ስኬቶችን ያገኛሉ እና ውጤቶችዎን ከጓደኞች ጋር ማጋራት ይችላሉ።',
    
    // Interactive Tips
    tutorialTipCategory: '"የመጽሐፍ ቅዱስ አጠቃላይ እውቀት" ንኩ ይሞክሩ',
    tutorialTipDifficulty: 'ለመጀመር "ቀላል" ይንኩ',

    // Guest User Messages
    notSignedIn: 'ገብተው አይደሉም',
    guestNoAccount: 'እንግዳ ሆነው እየተጫወቱ ነው። መለያ ለመፍጠር እና እድገትዎን ለማስቀመጥ ይግቡ።',
    ok: 'እሺ',
  },

  ko: {
    // Main Screen
    title: '더보기',
    subtitle: '추가 기능, 설정 및 개인화 옵션을 탐색하세요',
    
    // Menu Items
    profile: '프로필',
    profileSubtitle: '프로필 보기 및 편집',
    leaderboard: '리더보드',
    leaderboardSubtitle: '순위 보기 및 경쟁',
    progressAchievements: '진행 상황 및 업적',
    progressSubtitle: '영적 여정을 추적하세요',
    settings: '설정',
    settingsSubtitle: '앱 환경설정 및 구성',
    quizTutorial: '퀴즈 튜토리얼',
    tutorialSubtitle: '성경 퀴즈 플레이 방법 배우기',
    privacySettings: '개인정보 설정',
    privacySubtitle: '데이터 및 개인정보 설정 제어',
    
    // Footer
    appTitle: '킹덤 성경 퀴즈',
    footerTagline: '인터랙티브 학습을 통한 믿음 심화',
    
    // Tutorial Completion Screen
    tutorialComplete: '튜토리얼 완료!',
    tutorialCompleteMessage: '성경 퀴즈를 할 준비가 되었습니다. 복습이 필요하면 언제든지 여기서 튜토리얼을 이용할 수 있습니다.',
    backToMenu: '더보기 메뉴로 돌아가기',
    
    // Navigation Headers
    backButton: '뒤로',
    profileHeader: '프로필',
    leaderboardHeader: '리더보드',
    progressHeader: '진행 상황 및 업적',
    settingsHeader: '설정',
    tutorialHeader: '퀴즈 튜토리얼',
    privacyHeader: '개인정보 설정',
    
    // Privacy Settings Screen
    privacyTitle: '개인정보 설정',
    // privacySubtitle: '데이터 및 개인정보 설정 제어', // Duplicate - already defined at line 1189
    
    // Data Collection Section
    dataCollection: '데이터 수집',
    analytics: '분석',
    analyticsDescription: '익명의 사용 데이터를 공유하여 앱 개선에 도움을 주세요',
    
    // Community Privacy Section
    communityPrivacy: '커뮤니티 개인정보',
    communityVisibility: '커뮤니티 가시성',
    communityVisibilityDescription: '프로필과 퀴즈 활동을 누가 볼 수 있는지 제어하세요',
    public: '공개',
    publicDescription: '모든 사람에게 보임',
    friendsOnly: '친구만',
    friendsOnlyDescription: '친구에게만 보임',
    private: '비공개',
    privateDescription: '다른 사람에게 숨김',
    shareQuizResults: '퀴즈 결과 공유',
    shareQuizResultsDescription: '다른 사람이 귀하의 퀴즈 점수와 업적을 볼 수 있도록 허용',
    
    // Notifications Section
    notifications: '알림',
    emailNotifications: '이메일 알림',
    emailNotificationsDescription: '이메일로 업데이트 및 공지사항 받기',
    pushNotifications: '푸시 알림',
    pushNotificationsDescription: '기기에서 앱 알림 받기',
    
    // Data Rights Section
    yourDataRights: '데이터 권리',
    requestDataExport: '데이터 내보내기 요청',
    dataExportDescription: '모든 개인 데이터 다운로드 (GDPR)',
    
    // Legal Section
    legal: '법적 고지',
    privacyPolicy: '개인정보처리방침',
    termsOfService: '서비스 약관',
    
    // Account Management Section
    accountManagement: '계정 관리',
    deleteAccount: '계정 삭제',
    deleteAccountDescription: '계정과 모든 데이터를 영구적으로 삭제',
    
    // Alert Messages
    error: '오류',
    cancel: '취소',
    dataExportRequest: '데이터 내보내기 요청',
    dataExportMessage: 'GDPR에서 요구하는 대로 데이터 내보내기를 준비하여 30일 이내에 등록된 이메일 주소로 보내드리겠습니다.',
    requestExport: '내보내기 요청',
    exportRequested: '내보내기 요청됨',
    exportRequestedMessage: '데이터 내보내기 요청이 제출되었습니다. 30일 이내에 데이터가 포함된 이메일을 받으실 수 있습니다.',
    deleteAccountTitle: '계정 삭제',
    deleteAccountMessage: '계정과 모든 관련 데이터가 영구적으로 삭제됩니다. 이 작업은 되돌릴 수 없습니다.',
    accountDeleted: '계정 삭제됨',
    accountDeletedMessage: '계정이 영구적으로 삭제되었습니다.',
    failedUpdatePrivacy: '개인정보 설정 업데이트 실패',
    failedDataExport: '데이터 내보내기 요청 실패',
    failedDeleteAccount: '계정 삭제 실패. 다시 시도하세요.',
    
    // FirstQuizTutorial Component
    tutorialStepOf: '의',
    skipTutorial: '튜토리얼 건너뛰기',
    back: '뒤로',
    next: '다음',
    startQuiz: '퀴즈 시작',
    
    // Tutorial Steps
    tutorialStep1Title: '첫 번째 퀴즈에 오신 것을 환영합니다!',
    tutorialStep1Description: '성경 퀴즈가 어떻게 작동하는지 알아보겠습니다. 이 튜토리얼은 단 2분만 소요됩니다.',
    tutorialStep2Title: '카테고리 선택',
    tutorialStep2Description: '관심 있는 성경 주제를 선택하세요. 초보자는 "성경 일반 지식"으로 시작하는 것을 추천합니다.',
    tutorialStep2Action: '카테고리를 탭하여 계속하세요',
    tutorialStep3Title: '난이도 선택',
    tutorialStep3Description: '부드러운 시작을 위해 쉬움을, 도전을 위해 보통을, 성경 지식에 자신이 있다면 어려움을 선택하세요.',
    tutorialStep3Action: '난이도 레벨을 선택하세요',
    tutorialStep4Title: '문제 읽기',
    tutorialStep4Description: '각 문제를 주의 깊게 읽는 데 시간을 들이세요. 성경 문제는 종종 중요한 세부 사항을 포함합니다.',
    tutorialStep5Title: '답 선택',
    tutorialStep5Description: '올바른 답이라고 생각되는 답을 탭하세요. 문제당 30초가 주어지지만 서두르지 마세요!',
    tutorialStep5Action: '답 옵션을 탭하세요',
    tutorialStep6Title: '진행 상황 추적',
    tutorialStep6Description: '진행률 막대는 완료한 문제 수를 보여줍니다. 대부분의 퀴즈는 10문제로 구성됩니다.',
    tutorialStep7Title: '설명에서 배우기',
    tutorialStep7Description: '각 문제 후에 학습과 기억에 도움이 되는 설명을 보게 됩니다.',
    tutorialStep8Title: '결과를 축하하세요!',
    tutorialStep8Description: '마지막에 점수를 보고, 업적을 얻으며, 친구들과 결과를 공유할 수 있습니다.',
    
    // Interactive Tips
    tutorialTipCategory: '"성경 일반 지식" 탭해보세요',
    tutorialTipDifficulty: '시작하려면 "쉬움"을 탭하세요',

    // Guest User Messages
    notSignedIn: '로그인하지 않음',
    guestNoAccount: '게스트로 플레이 중입니다. 로그인하여 계정을 만들고 진행 상황을 저장하세요.',
    ok: '확인',
  },
};
